export const TOOLTIP = {
    deadlineRemain: (deadlineRemain:number)=>{ return deadlineRemain+" days until the application expires" },
    appProgress: (complete:number,outstanding:number)=> {return `Application: ${complete} of ${complete+outstanding} complete (${outstanding} outstanding)` },
};
